import { render, staticRenderFns } from "./HotSearch.vue?vue&type=template&id=2fff865a&scoped=true&"
import script from "./HotSearch.vue?vue&type=script&lang=js&"
export * from "./HotSearch.vue?vue&type=script&lang=js&"
import style0 from "./HotSearch.vue?vue&type=style&index=0&id=2fff865a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fff865a",
  null
  
)

export default component.exports